// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__3warB","load6":"Spinner_load6__1A1BG","round":"Spinner_round__2hvQq"};